import { Injectable } from '@angular/core';
import { Models } from '@ibexfusion/models';

import { RestProvider, RestService } from '../rest/rest.service';
import { RestfulService } from '../rest/restful';

@Injectable()
export class AccommodationWizardIdsService extends RestfulService<Models.AccommodationWizardIds> {

  constructor(private restService: RestService) {
    super(Models.AccommodationWizardIds);
    super.init();
  }

  public createProvider(): RestProvider {
    return this.restService.createProvider('accommodation-wizard-ids');
  }
}

